import { render } from "./MobileQuotItem.vue?vue&type=template&id=52ad818e"
import script from "./MobileQuotItem.vue?vue&type=script&lang=js"
export * from "./MobileQuotItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__